import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';
import { SiteAnnouncementList } from './SiteAnnouncementList/SiteAnnouncementList';
import {
  useCreateSiteAnnouncementSetupFlowPageModel,
  useEditSiteAnnouncementSetupFlowPageModel
} from './SiteAnnouncementForm/SiteAnnouncementSetupFlowPageModel';
import PermissionChecker from 'containers/PermissionChecker/PermissionChecker';
import { hasFuncs } from 'core/permission/PermissionDSL';
import { Permission } from 'core/auth/Permission';
import { ROUTE_PATH } from 'enum/RoutePath';
import { SiteAnnouncementSetupFlowPage } from './SiteAnnouncementForm/SiteAnnouncementSetupFlowPage';

export const SiteAnnouncements: React.FC = () => {
  const renderSiteAnnouncementList = (props: RouteComponentProps) => {
    return (
      <PermissionChecker
        permissionAware={hasFuncs(Permission.SITE_ANNOUNCEMENT_LIST_READ)}
        renderOtherwise={() => (
          <Redirect to={`${props.match.url}/${ROUTE_PATH.ERROR403}`} />
        )}
      >
        <SiteAnnouncementList />
      </PermissionChecker>
    );
  };

  const renderCreateSiteAnnouncementForm = (props: RouteComponentProps) => {
    return (
      <PermissionChecker
        permissionAware={hasFuncs(Permission.REPORT_ADMIN)}
        renderOtherwise={() => (
          <Redirect to={`${props.match.url}/${ROUTE_PATH.ERROR403}`} />
        )}
      >
        <SiteAnnouncementSetupFlowPage
          useModel={useCreateSiteAnnouncementSetupFlowPageModel}
        />
      </PermissionChecker>
    );
  };

  const renderEditSiteAnnouncementForm = (props: RouteComponentProps) => {
    return (
      <PermissionChecker
        permissionAware={hasFuncs(
          Permission.SITE_ANNOUNCEMENT_READ,
          Permission.SITE_ANNOUNCEMENT_WRITE
        )}
        renderOtherwise={() => (
          <Redirect to={`${props.match.url}/${ROUTE_PATH.ERROR403}`} />
        )}
      >
        <SiteAnnouncementSetupFlowPage
          useModel={useEditSiteAnnouncementSetupFlowPageModel}
        />
      </PermissionChecker>
    );
  };

  return (
    <Switch>
      <Route
        path={'/site-announcements/new'}
        render={renderCreateSiteAnnouncementForm}
      />
      <Route
        path={'/site-announcements/:id/edit'}
        render={renderEditSiteAnnouncementForm}
      />
      <Route render={renderSiteAnnouncementList} />
    </Switch>
  );
};
